import { BasicInfo } from '@/src/listings/types';
import { createContext, useContext } from 'react';

export const BasicInfoContext = createContext<BasicInfo>({} as BasicInfo);

export const BasicInfoProvider = ({ children, basicInfo }: { children: React.ReactNode; basicInfo: BasicInfo }) => {
  return <BasicInfoContext.Provider value={basicInfo}>{children}</BasicInfoContext.Provider>;
};

export const useBasicInfo = () => {
  return useContext(BasicInfoContext);
};
